import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class Hero extends Component() {
		mounted() {
			this.circles =
				this.el.querySelectorAll(".c-hero__ripple .c-ripple__circle") ||
				[];

			this.content = this.el.querySelectorAll(".c-hero__content") || [];
		}

		animations() {
			gsap.set(this.circles, { scale: 0, transformOrigin: "50% 50%" });

			gsap.set(this.content, {
				y: "20%",
				opacity: 0,
			});

			this.anim = gsap.timeline();

			this.anim.to(
				this.circles,
				{
					scale: 1,
					ease: "back.out",
					duration: 0.6,
					stagger: 0.04,
				},
				0.2
			);

			this.anim.to(
				this.content,
				{
					y: 0,
					opacity: 1,
					ease: "sine.out",
					duration: 0.6,
					stagger: 0.15,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
